import { getLogger } from '@williamhill/rosi-ui-shared/src/lib/logger-plus';
import { useEffect } from 'react';

const logger = getLogger('bet-tracker/use-scripts');

export function useScripts({ urls, onScriptsLoaded }: { urls: string[]; onScriptsLoaded: () => void }) {
  useEffect(() => {
    const scripts: HTMLScriptElement[] = [];
    async function createScripts() {
      return Promise.all(
        urls.map(
          url =>
            new Promise((resolve, reject) => {
              const script = document.createElement('script');
              script.setAttribute('src', url);
              script.setAttribute('defer', 'defer');
              script.onload = resolve;
              script.onerror = () => reject();
              document.body.appendChild(script);
              scripts.push(script);
            })
        )
      )
        .then(onScriptsLoaded)
        .catch(() => logger.error([urls], 'Failed to load scripts'));
    }
    createScripts();

    return () => scripts.forEach(script => document.body.removeChild(script));
  }, [urls, onScriptsLoaded]);
}
